/**
 * Roles originate in MyBestUser and are copied onto the b2b user at login.
 * b2b-web admits two groups; every other role (student, solo) is turned away.
 */
export const ADMIN_ROLES: readonly string[] = [
  "super",
  "admin",
  "editor",
  "developer",
  "educational_cons",
];

export const SCHOOL_STAFF_ROLES: readonly string[] = ["teacher", "principal", "secretary"];

/** Where a role lands after signing in, or null if it has no home here. */
export function landingPathFor(role: string | null | undefined): "/admin" | "/teacher" | null {
  if (!role) return null;
  if (ADMIN_ROLES.includes(role)) return "/admin";
  if (SCHOOL_STAFF_ROLES.includes(role)) return "/teacher";
  return null;
}
